import { FC } from 'react';
import { flyoutHeaderLabelSX, flyoutHeaderSX } from '@/components/content/Header/styles/navBar/dropMenu';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import CloseOutlinedIcon from '@mui/icons-material/CloseOutlined';
import { Box, Button, Stack, Typography } from '@mui/material';
import { ContentRecommendation } from '@/components/content/ContentRecommendation';
import { headerPlayButtonMobSX } from '@/components/content/Header/styles/container';
import { HeaderPlayButton } from '@/components/content/Header/parts/HeaderPlayButton';
import { CLOSE, SHOW_MENU } from '@/data/constants/headerMenu';
import { useLocalization } from '@/data/Localization';
import { Linkable } from '@/components/blocks/Linkable';

export const MobilePopOver:FC<{handleLevelNavigation:(action:string)=>void}> = ({handleLevelNavigation}) => {
    const AllCategoriesNL = useLocalization('AllCategoriesExpandedMenu');
    const HeaderLabels = useLocalization('Header');
    const RouteLocal = useLocalization('Routes');
    return(
        <Box sx={{ width: 300, p:2, pl: 4 }}>
            <Button
                variant="textButton"
                onClick={()=>handleLevelNavigation(CLOSE)}
                sx={{ position: 'absolute', right: 16, top: 16}} 
            >
                <CloseOutlinedIcon sx={{ fontSize: 18, color: 'grey' }} titleAccess={AllCategoriesNL.Actions.CLoseMenu.t()} />
            </Button>
            <Stack sx={flyoutHeaderSX}>
                <Box mb={0.5}>
                    <ContentRecommendation
                        id={`HeaderStoreLogo`}
                        properties={{ emsName: 'HeaderStoreLogo' }}
                    />
                </Box>
                <Button 
                    onClick={() => handleLevelNavigation(SHOW_MENU)} 
                    sx={flyoutHeaderLabelSX}
                    variant="textButton"
                >
                    <Typography component="span">{AllCategoriesNL.AllCategoriesLabel.t()}</Typography>
                    <ArrowForwardIosIcon sx={{ fontSize: 16 }} />
                </Button>
            </Stack>
            <Stack rowGap={5} mt={1}>
                <Stack rowGap={2}>
                    <Linkable href={HeaderLabels.NavBar.ActiesLink.t()} role="link">{HeaderLabels.NavBar.Acties.t()}</Linkable>
                    <Linkable href={HeaderLabels.NavBar.CadeausLink.t()} role="link">{HeaderLabels.NavBar.Cadeaus.t()}</Linkable>
                    <Linkable target="_blank" href={HeaderLabels.NavBar.KadokaartLink.t()} role="link">{HeaderLabels.NavBar.Kadokaart.t()}</Linkable>
                </Stack>
                <HeaderPlayButton sx={headerPlayButtonMobSX} />
                <Stack rowGap={2}>
                    <Linkable id="storeLocatorQuickLink" href={`/${RouteLocal.StoreLocator.route.t()}`} role="link">{HeaderLabels.Actions.Stores.t()}</Linkable>
                    <ContentRecommendation id="IT-Header-Klantenservice-Link-eSpot_rv" properties={{emsName:"IT-Header-Klantenservice-Link-eSpot_rv"}} />
                    <Linkable id="header_usp_my_account_link" href={`/${RouteLocal.Account.route.t()}`} role="link">{HeaderLabels.Actions.MyAccount.t()}</Linkable>
                </Stack>
            </Stack>
        </Box>
    );
}